import React, { useState, useEffect } from "react";
import "../style/widget.css";
import { Link } from "react-router-dom";
import StoreIcon from "@mui/icons-material/Store";
import LocalMallIcon from "@mui/icons-material/LocalMall";
import Chart from "./Chart";
import Product_table from "./Product_table";
import axiosInstance from "../axios_helper/axiosInstance";

export default function Widget() {
  const [shop1Categories, setShop1Categories] = useState(0); // Default value set to 0
  const [shop2Categories, setShop2Categories] = useState(0); // Default value set to 0
  const [shop1Items, setShop1Items] = useState(0); // Default value set to 0
  const [shop2Items, setShop2Items] = useState(0); // Default value set to 0
  const [shop1NetWeight, setShop1NetWeight] = useState(0); // Total net weight for Shop 1
  const [shop2NetWeight, setShop2NetWeight] = useState(0); // Total net weight for Shop 2

  useEffect(() => {
    fetchShopCategories();
    fetchStockItemsshop1();
    fetchStockItemsshop2();
  }, []);

  const fetchShopCategories = () => {
    axiosInstance.get('/categories/?shop=1')
      .then(response => {
        setShop1Categories(response.data.length);
      })
      .catch(error => {
        console.error('Error fetching Shop-1 categories:', error);
      });

    axiosInstance.get('/categories/?shop=2')
      .then(response => {
        setShop2Categories(response.data.length);
      })
      .catch(error => {
        console.error('Error fetching Shop-2 categories:', error);
      });
  };

  const fetchStockItemsshop1 = () => {
    axiosInstance.get('/stock-items/?shop=1')
      .then(response => {
        setShop1Items(response.data.length); // Set the length of the data

        // Calculate total net weight for Shop 1
        const totalNetWeight = response.data.reduce((total, item) => total + parseFloat(item.nw || 0), 0);
        setShop1NetWeight(totalNetWeight); // Set the net weight
      })
      .catch(error => {
        console.error('Error fetching stock items for Shop 1:', error);
      });
  };

  const fetchStockItemsshop2 = () => {
    axiosInstance.get('/stock-items/?shop=2')
      .then(response => {
        setShop2Items(response.data.length); // Set the length of the data

        // Calculate total net weight for Shop 2
        const totalNetWeight = response.data.reduce((total, item) => total + parseFloat(item.nw || 0), 0);
        setShop2NetWeight(totalNetWeight); // Set the net weight
      })
      .catch(error => {
        console.error('Error fetching stock items for Shop 2:', error);
      });
  };

  return (
    <>
      <div className="widget-container-1">
        <div className="widget_box widget-1">
          <div className="left">
            <span className="title">MJ Shop total Categories</span>
            <span className="number">{shop1Categories}</span>
            <Link to="/mj-shopcategory"><span className="link">See all</span></Link>
          </div>
          <div className="right">
            <StoreIcon style={{ fontSize: 45, color: "#7451f8" }} />
          </div>
        </div>
        <div className="widget_box widget-2">
          <div className="left">
            <span className="title">MJ Shop<br/>all Items</span>
            <span className="number">{shop1Items}</span>
            <Link to="/mj-shop"><span className="link">See all</span></Link>
          </div>
          <div className="right">
            <LocalMallIcon style={{ fontSize: 45, color: "#7451f8", marginBottom:"70px" }} />
            <span className="n_wt">
              N.wt: <br /> 
              {shop1NetWeight
                ? (parseFloat(shop1NetWeight).toFixed(3))  // Ensures 3 decimal places
                : "0.000"}g
            </span>
          </div>
        </div>
        <div className="widget_box widget-3">
          <div className="left">
            <span className="title">RMJ Shop total Categories</span>
            <span className="number">{shop2Categories}</span>
            <Link to="/rmj-shopcategory"><span className="link">See all</span></Link>
          </div>
          <div className="right">
            <StoreIcon style={{ fontSize: 45, color: "#7451f8" }} />
          </div>
        </div>
        <div className="widget_box widget-4">
          <div className="left">
            <span className="title">RMJ Shop <br/>all Items</span>
            <span className="number">{shop2Items}</span>
            <Link to="/rmj-shop"><span className="link">See all</span></Link>
          </div>
          <div className="right">
            <LocalMallIcon style={{ fontSize: 45, color: "#7451f8", marginBottom:"70px" }} />
            <span className="n_wt">
              N.wt: <br /> 
              {shop2NetWeight
                ? (parseFloat(shop2NetWeight).toFixed(3))  // Ensures 3 decimal places
                : "0.000"}g
            </span>
          </div>
        </div>
      </div>
      <div className="widget-container-2">
        <div className="table">
          <div className="heading">
            <h2>Add Recently Item</h2>
          </div>
          <Product_table />
        </div>
        <div className="chart">
          <div className="heading">
            <h2>Website User Chart</h2>
          </div>
          <div className="canvas_chart mt-4">
            <Chart />
          </div>
        </div>
      </div>
    </>
  );
}
